import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import { Calendar } from '@fullcalendar/core'
import bootstrapPlugin from '@fullcalendar/bootstrap'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import ptLocale from '@fullcalendar/core/locales/pt-br'
import { BSpinner, BToast } from 'bootstrap-vue'
import agendaUtil from '@/util/agendaUtil'
import mensagens from '@/util/mensagens'
import util from '@/util'

export default {
  name: 'agenda',
  components: {
    cabecalho,
    menuLateral,
    'b-spinner': BSpinner,
    'b-toast': BToast,
    Calendar,
    FullCalendar
  },

  computed: {
    calendarOptions () {
      return {
        ...this.configuracoes,
        ...this.acoes
      }
    },

    configuracoes () {
      return {
        plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin, bootstrapPlugin ],
        locales: [ptLocale],
        themeSystem: 'bootstrap',
        initialView: 'dayGridMonth',
        weekends: true,
        height: 650,
        events: this.popularAgenda,
        eventOrderStrict: true,
        eventOrder: '-ehEventoAniversario',
        headerToolbar: {
          left: 'prev next today',
          center: 'title',
          right: 'dayGridMonth timeGridWeek timeGridDay listEvents'
        },
        views: {
          dayGridMonth: {// MÊS
            titleFormat: { year: 'numeric', month: 'long' },
            eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: false },
            expandRows: true,
            displayEventTime: true,
            displayEventEnd: false,
            showNonCurrentDates: false,
            fixedWeekCount: false
          },
          timeGridWeek: {// SEMANA
            titleFormat: { year: 'numeric', month: 'short', day: 'numeric' },
            slotLabelFormat: { hour: 'numeric', minute: '2-digit' },
            eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: false },
            expandRows: true,
            displayEventTime: true,
            displayEventEnd: false,
            slotEventOverlap: false,
            nowIndicator: true,
            scrollTimeReset: false,
            scrollTime: util.formatarData(new Date(), 'HH:mm:ss')
          },
          timeGridDay: {// DIA
            titleFormat: { year: 'numeric', month: 'long', day: 'numeric' },
            slotLabelFormat: { hour: 'numeric', minute: '2-digit' },
            eventTimeFormat: { hour: 'numeric', minute: '2-digit', meridiem: false },
            expandRows: true,
            displayEventTime: true,
            displayEventEnd: false,
            slotEventOverlap: false,
            nowIndicator: true,
            scrollTimeReset: false,
            scrollTime: util.formatarData(new Date(), 'HH:mm:ss')
          }
        },
        eventDidMount ($event) {
          agendaUtil.customizacaoLayoutEvento($event, document, this)
        },
        customButtons: {
          listEvents: {
            text: 'Listagem',
            click: function () {
              window._Vue.$router.push({ name: 'listagem-eventos' })
            }
          }
        }
      }
    },

    acoes () {
      return {
        eventClick: this.editarEvento
      }
    }
  },

  data: () => {
    return {
      flagsDeControle: {
        autenticacao: {
          financeiro: false,
          faturamento: false,
          office: true,
          mirt: false
        },
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      }
    }
  },

  mounted () {
  },

  methods: {
    popularAgenda (calendarioDTO, callbackSucesso, callbackFalha) {
      let eventosCalendario = []

      const dataInicio = util.formatarData(calendarioDTO.start, 'YYYY-MM-DD 00:00')
      const dataFinal = util.formatarData(calendarioDTO.end, 'YYYY-MM-DD 23:59')
      let parametrosRequisicao = {
        'filtros': {
          'f_dtstart': dataInicio,
          'f_dtend': dataFinal
        }
      }
      this.axios.post('/agenda/calendario', parametrosRequisicao)
        .then(resposta => {
          const listaEventosApi = resposta.data.retorno.dados.f_events
          listaEventosApi.map(evento => {
            // if (!util.valorVazio(evento.f_uuid)) { // <-- bloqueia f_uuid nulo
            eventosCalendario.push({
              id: evento.f_uuid,
              title: evento.f_summary,
              start: evento.f_dtstart,
              end: evento.f_dtend
            })
            // }
          })
          const listaAniversariosApi = resposta.data.retorno.dados.f_birthdays
          listaAniversariosApi.map(aniversario => {
            eventosCalendario.push({
              title: aniversario.f_name || '',
              start: aniversario.f_birthday,
              allDay: true,
              ehEventoAniversario: true,
              extendedProps: {
                nome: aniversario.f_name || '',
                email: aniversario.f_email || '',
                foto: aniversario.f_photo,
                idCliente: aniversario.f_id,
                permitido: this.flagsDeControle.autenticacao.office,
                tipo: aniversario.tabela,
                abaCliente: resposta.data.retorno.dados.abaCliente,
                image64: aniversario.image64
              }
            })
          })
          callbackSucesso(eventosCalendario)
        }).catch(e => {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
          callbackFalha(e)
        })
    },

    incluirEvento () {
      this.$router.push({ name: 'cadastro-eventos' })
    },

    redirecionarParaListagemConvites () {
      this.$router.push({ name: 'listagem-convites' })
    },

    editarEvento ({ event }) {
      if (!event || !event.id) return
      if (!event || util.valorVazio(event.id)) {
        return // Impede clique sem UUID válido
      }
      if (!util.valorVazio(event.id)) {
        window._Vue.$router.push({ name: 'edicao-eventos', params: { id: event.id } })
      }
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    }
  }
}
